import React, { Component } from 'react';
import * as Config from './../config/Config';
import * as Common from './../helpers/Common';
import * as User from './../helpers/User';
import Highcharts from './../components/Highcharts';
import MyJourneyList from './MyJourneyLists';
const $=window.$;

//const $=window.$;
// const win=window;

class MyJourney extends Component {
	constructor(props) {
		super(props);

        this.state={
        	myjourney_results : [],
            chartvalue : [],
            chart:'',
            dynamicchart:'',
            pending_lrs:'',
            completed_lrs:'',
            pending_dlrs:'',
            completed_dlrs:'',
            learningcount:'',
            dynamiclearningcount:'',
            lrroomwisetab:[],
						lrroomwisetablist:[],
					//	lrmodule:[],
						//lrmodulewise:[],
						dlrroomwise:[],
						// dlr_module_name_list:[],
						//dlrroomwise_array_list:[],
						specialExpiryDate:''
        };


				this.getLrinfo=this.getLrinfo.bind(this);

	}
	getTabs(){
	           window.$('#parentHorizontalTab').easyResponsiveTabs({
	                type: 'default', //Types: default, vertical, accordion
	                width: 'auto', //auto or any width like 600px
	                fit: true, // 100% fit in a container
	                //closed: 'accordion', // Start closed if in accordion view
	                tabidentify: 'hor_1', // The tab groups identifier
	                activate: function (event) { // Callback function if tab is switched

	                    var $tab = $(this);
	                    var $info = $('#nested-tabInfo');
	                    var $name = $('span', $info);

	                    $name.text($tab.text());

	                    $info.show();
	                }
	            });

    }
	getJourney(){
			let learnerID = Common.getUserData("id", true);
			let pinNo = Common.getUserData("pinNo", true);
			let pinID = Common.getUserData("pinID", true);
			let corporateID = Common.getUserData("corporateID", true);
			let productID = Common.getUserData("productID", true);

			let specialExpiryDate = Common.getUserData("specialExpiryDate", true);
			// let d = new Date(specialExpiry);
			// let specialExpiryDate = d.toDateString('d-M-Y');

			//alert(learnerID+'learnerID '+pinNo+'pinNo '+pinID+'pinID '+corporateID+'corporateID productID'+productID); return;
			Common.reactLoader("show", "Please wait...");
    	fetch(Config.domainUrl+'learning/myjourney', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
									'Authorization':'Bearer ' +Common.getTokenData()
                },
                  body: JSON.stringify({
                    learnerID:learnerID,
										pinNo:pinNo,
										pinID:pinID,
										corporateID:corporateID,
										productID:productID
                  })
                }).then((response) => response.json())
               .then((responseJson) => {
								 //alert(responseJson.myjourney_results.pending_lrs);
               		//learning room
               	if(responseJson.status != 0){
               		let pending_lrs=(responseJson.myjourney_results.pending_lrs!=undefined) ? responseJson.myjourney_results.pending_lrs : '';
               		let completed_lrs=(responseJson.myjourney_results.completed_lrs!=undefined) ? responseJson.myjourney_results.completed_lrs : '';
	               if(responseJson.myjourney_results.completed_lrs==undefined || responseJson.myjourney_results.completed_lrs==0){
	               		completed_lrs=0;
	               }
	               if(responseJson.myjourney_results.pending_lrs==undefined || responseJson.myjourney_results.pending_lrs==0){
	               		pending_lrs=0;
	               }


				  let data=[
	               	{
	                    name: 'Completed',
	                    y:completed_lrs,
	                    sliced: true,
                      selected: true
	                }, {
	                    name: 'Pending',
	                    y: pending_lrs
	                }];


               	let learningcount=(responseJson.myjourney_results.total_lrs!=undefined) ? responseJson.myjourney_results.total_lrs : '';
               	let chart=<Highcharts key={`chart_1`} data={data} title={`Learning Rooms = ${learningcount}`} name='Learning Rooms' charttype='pie' />;

               	//dynamic learning room
               	let pending_dlrs=(responseJson.myjourney_results.pending_dlrs!=undefined) ? responseJson.myjourney_results.pending_dlrs : '';
               	let completed_dlrs=(responseJson.myjourney_results.completed_dlrs!=undefined) ? responseJson.myjourney_results.completed_dlrs : '';
	               if(responseJson.myjourney_results.completed_dlrs==undefined || responseJson.myjourney_results.completed_dlrs==0){
	               		completed_dlrs=0;
	               }
	               if(responseJson.myjourney_results.pending_dlrs==undefined || responseJson.myjourney_results.pending_dlrs==0){
	               		pending_dlrs=0;
	               }


				  let dynamicdata=[
	               	{
	                    name: 'Completed',
	                    y:completed_dlrs,
	                    sliced: true,
                        selected: true
	                }, {
	                    name: 'Pending',
	                    y: pending_dlrs
	                }];


               	let dynamiclearningcount=(responseJson.myjourney_results.total_dlrs!=undefined) ? responseJson.myjourney_results.total_dlrs : '';
               	let dynamicchart=<Highcharts key={`dynamicchart_1`} data={dynamicdata} title={`Dynamic Learning Rooms = ${dynamiclearningcount}`} name='Dynamic Learning Rooms' charttype='pie' />;

	        setTimeout(function() {
			        if(completed_lrs !=0 || pending_lrs !=0){
								$("#lritem").show();
							}
			        if(completed_dlrs !=0 || pending_dlrs !=0){
									$("#dlritem").show();
							}
							if(learningcount > 0){
								$(".lrwise").hide();
								$(".lrroomwise").show();
			        }else{
			          $(".lrroomwise").hide();
			          $(".lrwise").show();
							}
							if(dynamiclearningcount > 0){
								$(".dlrroomwise").show();
			        }else{
			         	$(".dlrroomwise").hide();
			        }
					 },2000);

                let lrroomwisetab     = (responseJson.myjourney_results.lrroomwise!=undefined) ? responseJson.myjourney_results.lrroomwise : '';
								let lrroomwisetablist = (responseJson.myjourney_results.loopinfo!=undefined) ? responseJson.myjourney_results.loopinfo : '';
								// let lrmodule          = (responseJson.myjourney_results.lrmodule!=undefined) ? responseJson.myjourney_results.lrmodule : '';
								// let lrmodulewise      = (responseJson.myjourney_results.lrmodulewise!=undefined) ? responseJson.myjourney_results.lrmodulewise : '';

								let dlrroomwise =(responseJson.myjourney_results.dlrroomwise!=undefined) ? responseJson.myjourney_results.dlrroomwise : '';
								// let dlr_module_name_list = (responseJson.myjourney_results.dlr_module_name_list!=undefined) ? responseJson.myjourney_results.dlr_module_name_list : '';
								// let dlrroomwise_array_list = (responseJson.myjourney_results.dlrroomwise_array_list!=undefined) ? responseJson.myjourney_results.dlrroomwise_array_list : '';
								
								//console.log(dlrroomwise);
                this.setState({
                    myjourney_results: responseJson.myjourney_results,
                    chart:chart,
                    dynamicchart:dynamicchart,
                    pending_lrs:pending_lrs,
                    completed_lrs:completed_lrs,
                    pending_dlrs:pending_dlrs,
                    completed_dlrs:completed_dlrs,
                    learningcount:learningcount,
                    dynamiclearningcount:dynamiclearningcount,
                    lrroomwisetab:lrroomwisetab,
										lrroomwisetablist:lrroomwisetablist,
										//lrmodule:lrmodule,
										// lrmodulewise:lrmodulewise,
										dlrroomwise:dlrroomwise,
										// dlr_module_name_list:dlr_module_name_list,
										//dlrroomwise_array_list:dlrroomwise_array_list,
										specialExpiryDate:specialExpiryDate
                });
             }

																Common.reactLoader("hide");
																Common.downTabClose();
   		 });

    }

		// roomChange(e){
		// 			$(".rooms").hide();
		// 			$("#"+e).show();
		// 			$("."+e).css('background','#23a64d');
	  // }

	componentDidMount() {
		$("#lritem").hide();
		$("#dlritem").hide();
		//$(".lrwise").hide();
		//$(".dlrroomwise").hide();
		$(".rooms").hide();
		$("#room1").show();
	 	this.getJourney();
	 	this.getTabs();
		//Common.showSmallLeftMenu();

	}

	getLrinfo(type,lr_id,dlr_id){
					// alert(type);
					this.props.switchPanel(type,lr_id,dlr_id);
	}

		render() {
			const {Webview} = this.props;
		return (

		 <section id="contentsection" className="contentarea">
          <div className="inner-title-bg journey-tit-bg">
            <h1> <span> <img src={process.env.PUBLIC_URL+'/images/img-myjourney.jpg'} align="absmiddle" alt="" border="0" /> </span> My Journey<br />
              <span className="subtitle">A quick view of my progress in the program</span></h1>
          </div>
          <div className="main-inner">

            <div className="border-box">

              <section id="semana-scroll- " className="scroll1">
                <section className="viewport">
                  <section className="overview">
                    <div className="inner-content">

                      <div className="myjourney-chart">
                        <div className="myjourneychart-left">
                          	{this.state.chart}
	                        	<div className="chart-complete" id="lritem">
		                          <div className="chart-legends">
		                            <span className="complete-bg"></span>
		                            <p>Completed : {this.state.completed_lrs}</p>
		                          </div>
		                          <div className="chart-legends">
		                            <span className="in-complete-bg"></span>
		                            <p>Pending : {this.state.pending_lrs}</p>
		                          </div>
		                         </div>
                        </div>
                        <div className="myjourneychart-right">
                          	{this.state.dynamicchart}
                          	<div className="chart-complete" id="dlritem">
		                          <div className="chart-legends">
		                            <span className="complete-bg"></span>
		                            <p>Completed : {this.state.completed_dlrs}</p>
		                          </div>
		                          <div className="chart-legends">
		                            <span className="in-complete-bg"></span>
		                            <p>Pending : {this.state.pending_dlrs}</p>
		                          </div>
		                    </div>

                        </div>
                        <div className="chartstatus"> Program : {this.state.myjourney_results.product_name}<br />
                          Your login expires on: <b>{this.state.specialExpiryDate}</b> </div>
                      </div>

                      	<div className="myourney-inner">
												<div className="abbrevationmyjourner"><ul>
                                  {/* <li><strong>PS</strong> - Performance Score</li> */}
                                  <li><img src={process.env.PUBLIC_URL+"/images/status-completed.png"} alt="" title="" /> - Completed</li>
                                  <li><img src={process.env.PUBLIC_URL+"/images/status-notcompleted.png"} alt="" title="" /> - In Progress</li>
                                  <li><img src={process.env.PUBLIC_URL+"/images/start-small.png"} alt="" title="" /> - Yet to start</li>
                                </ul></div>
	                        <div id="parentHorizontalTab" className="tab_wide">
	                          <ul className="resp-tabs-list hor_1">
	                            <li ><span className="lrroomwise">LRs-wise</span>
															{/* <span className="lrwise">LRs wise</span> */}
															</li>
	                            {/* <li ><span className="lrroomwise">LRs Module-wise</span><span className="lrwise">Module-wise</span></li> */}
	                            <li className="dlrroomwise">DLRs-wise</li>
	                            {/* <li className="dlrroomwise">DLRs Module-wise</li> */}
	                          </ul>
	                      		<MyJourneyList tabsdata={this.state.lrroomwisetab} view_type={Webview} tabsdatalist={this.state.lrroomwisetablist} /*lrmodule={this.state.lrmodule}*/ /* lrmodulewiselist={this.state.lrmodulewise} */ dlrroomwiselist={this.state.dlrroomwise} /*dlr_module_name_list={this.state.dlr_module_name_list} */ /*dlrroomwise_array_list={this.state.dlrroomwise_array_list}*/ getLrinfo={this.getLrinfo}/>
	                      	</div>
                      	</div>

                    </div>
                  </section>
                </section>
              </section>
            </div>
          </div>
        </section>

			);

		}
}

export default MyJourney;



// WEBPACK FOOTER //
// ./src/learning_records/MyJourney.js